export function StubComponent() {
  return null;
}
